// DiscoverMapListSkeleton.jsx
import "./discoverMapPageSkeleton.css";

const SkeletonItem = () => (
	<div className="sf-map-card sf-map-skeleton">
		<div className="sf-map-skeleton-media shimmer" />

		<div className="sf-map-skeleton-body">
			<div className="sf-map-skeleton-line title shimmer" />
			<div className="sf-map-skeleton-line address shimmer" />

			<div className="sf-map-skeleton-services">
				<div className="sf-map-skeleton-service shimmer" />
				<div className="sf-map-skeleton-service shimmer" />
			</div>
		</div>
	</div>
);

const DiscoverMapListSkeleton = ({ count = 6 }) => {
	return (
		<>
			{Array.from({ length: count }).map((_, i) => (
				<SkeletonItem key={i} />
			))}
		</>
	);
};

export default DiscoverMapListSkeleton;
